import React, { useState, useEffect, useRef } from "react";
import { Container, Navbar, Nav, NavDropdown, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
// import { showLogin, showRegister } from "actions/auth";
import { showLogin, showRegister } from "actions/ui_control";

import { Link, useLocation } from "react-router-dom";
import Authentication from "components/Authentication/Authentication";
import Logo from "./Logo";

function MyNavbar({ logout, isLoggedIn, user, isDarkTheme, ...props }) {
  const [expanded, setExpanded] = useState(false);

  const navRef = useRef(null);

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Function to get user's initials from their name
  const getUserInitials = (name) => {
    const nameParts = name.split(" ");
    return nameParts.map((part) => part[0].toUpperCase()).join("");
  };

  const closeDropdown = (event) => {
    setExpanded(false);
  };
  const displayLogin = () => {
    dispatch(showLogin());
  };
  const displayRegister = () => {
    dispatch(showRegister());
  };
  return (
    <>
      <Navbar
        expand="lg"
        ref={navRef}
        className="py-3"
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
        style={isLoggedIn ? { borderBottom: "1px groove #4C4B56" } : {}}
      >
        <Container>
          {/* LOGO */}

          <Logo handleClick={closeDropdown} isDarkTheme={isDarkTheme} />
          {/* Language Dropdown */}

          <div className="d-flex align-items-center d-lg-none order-lg-1 ml-auto pe-2 pe-sm-3 ps-0 ps-sm-e ms-auto">
            {isLoggedIn ? (
              <Link
                className="btn login-button d-none d-sm-block"
                onClick={() => {
                  setExpanded(false);
                  logout();
                }}
              >
                Log Out
              </Link>
            ) : (
              // <Link
              //   className="btn btn-dark ml-auto ms-auto button-purple-solid me-3 d-none d-sm-block"
              //   onClick={() => {
              //     setExpanded(false);
              //     // setShowLogin(true);
              //     displayLogin();
              //   }}
              // >
              //   Login
              // </Link>
              <Button
                className="btn btn-dark ml-auto ms-auto button-purple-solid me-0 me-sm-3"
                onClick={() => {
                  setExpanded(false);
                  // setShowSignup(true);
                  displayRegister();
                }}
              >
                Sign Up
              </Button>
            )}
            <NavDropdown
              className="d-none d-sm-block"
              title={
                <span>
                  <i className="bi bi-globe"></i>
                </span>
              }
              id="basic-nav-dropdown"
              menualign="center"
            >
              <NavDropdown.Item href="#">English</NavDropdown.Item>
              {/*<NavDropdown.Item href="#">Spanish</NavDropdown.Item>*/}
              {/*<NavDropdown.Item href="#">French</NavDropdown.Item>*/}
            </NavDropdown>
          </div>
          {/* <Link
            className="btn btn-dark mx-2 button-purple-solid"
            onClick={() => {
              setExpanded(false);
              // setShowLogin(true);
              displayLogin();
            }}
          >
            Login
          </Link> */}
          {/* Navbar Toggler */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          {/* Navbar Links */}
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="d-lg-flex justify-content-center"
          >
            {/* Authentication Buttons in small and medium screens */}
            {isLoggedIn ? (
              <>
                <Nav
                  className="d-none d-lg-flex position-absolute w-100 justify-content-center "
                  style={{ left: 0 }}
                >
                  <Link
                    onClick={closeDropdown}
                    className={
                      "nav-link px-3 " +
                      (location.pathname.startsWith("/dashboard") &&
                        "nav-link-active")
                    }
                    to="/dashboard"
                  >
                    Dashboard
                  </Link>
                  <Link
                    onClick={closeDropdown}
                    className={
                      "nav-link px-3 " +
                      (location.pathname.startsWith("/dca") &&
                        "nav-link-active")
                    }
                    to="/dca"
                  >
                    DCA
                  </Link>
                  <Link
                    onClick={closeDropdown}
                    className={
                      "nav-link px-3 " +
                      (location.pathname.startsWith("/brokers") &&
                        "nav-link-active")
                    }
                    to="/brokers"
                  >
                    Brokers
                  </Link>
                </Nav>

                <Nav className="d-block d-lg-none">
                  <Link
                    onClick={closeDropdown}
                    className="nav-link"
                    to="/dashboard"
                  >
                    Dashboard
                  </Link>
                  <Link onClick={closeDropdown} className="nav-link" to="/dca">
                    DCA
                  </Link>
                  <Link
                    onClick={closeDropdown}
                    className="nav-link"
                    to="/brokers"
                  >
                    Brokers
                  </Link>
                </Nav>
                <Nav className="d-flex d-lg-none">
                  {isLoggedIn ? (
                    <>
                      <Link to="/profile" className="nav-link">
                        Profile
                      </Link>
                      <Link
                        className="nav-link d-sm-none"
                        onClick={() => {
                          setExpanded(false);
                          logout();
                        }}
                      >
                        Log Out
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link
                        className="nav-link d-lg-none"
                        onClick={() => {
                          setExpanded(false);
                          // setShowLogin(true);
                          displayLogin();
                        }}
                      >
                        Login
                      </Link>
                      <Link
                        className="nav-link d-none"
                        onClick={() => {
                          setExpanded(false);
                          // setShowSignup(true);
                          displayRegister();
                        }}
                      >
                        Sign Up
                      </Link>
                    </>
                  )}
                </Nav>
              </>
            ) : (
              <Nav className="me-auto">
                <Link
                  onClick={closeDropdown}
                  className="nav-link"
                  to="/how-it-works"
                >
                  How it works?
                </Link>
                <Link
                  onClick={closeDropdown}
                  className="nav-link"
                  to="/about-us"
                >
                  About Us
                </Link>
                <Link
                  onClick={closeDropdown}
                  className="nav-link"
                  to="/contact-us"
                >
                  Contact Us
                </Link>
                <Link
                  onClick={closeDropdown}
                  className="nav-link"
                  to="/pricing"
                >
                  Pricing
                </Link>
              </Nav>
            )}
            {/* Language Dropdown */}
            <NavDropdown
              title={
                <span>
                  <i className="bi bi-globe"></i> ENG
                </span>
              }
              id="basic-nav-dropdown-1"
              className="d-none d-lg-block ms-auto px-3"
            >
              <NavDropdown.Item href="#">English</NavDropdown.Item>
              {/*<NavDropdown.Item href="#">Spanish</NavDropdown.Item>*/}
              {/*<NavDropdown.Item href="#">French</NavDropdown.Item>*/}
            </NavDropdown>

            {/* Authentication Buttons in large screens */}
            <div className="d-none d-lg-flex" style={{ zIndex: 1 }}>
              {isLoggedIn ? (
                <>
                  <div
                    className="profile-button-container"
                    style={{ zIndex: 1 }}
                  >
                    <Link to="/profile" className="nav-link profile-button">
                      {getUserInitials(user.user.username)}
                    </Link>
                  </div>
                  <Link
                    className="btn login-button"
                    onClick={() => {
                      setExpanded(false);
                      logout();
                    }}
                  >
                    Log Out
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    className="btn login-button ms-3"
                    onClick={() => {
                      setExpanded(false);
                      // setShowLogin(true);
                      displayLogin();
                    }}
                  >
                    Login
                  </Link>
                  <Button
                    className="btn btn-dark ms-3 button-purple-solid"
                    onClick={() => {
                      setExpanded(false);
                      // setShowSignup(true);
                      displayRegister();
                    }}
                  >
                    Sign Up
                  </Button>
                </>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {/* Authentication Modals section */}

      <Authentication />
    </>
  );
}

export default MyNavbar;
